var $ = require('jquery')

module.exports = function(gameCode) {
  var dfd = new $.Deferred()

  $.getJSON(
    '/game-getactivityinfo-' + gameCode + '.html'
  ).done(function(resp) {
    resp = resp || {}

    if (resp && resp.msg === 'success') {
      return dfd.resolve(resp.data || null)
    }

    return dfd.resolve(null)
  })

  return dfd.promise()

}
